class AlgoliaHitCarousel extends HTMLElement {
  constructor() {
    super();
    this.render = this.render.bind(this);
  }

  /**
   * Renders and returns content.
   * @param {string} handle - The shopify product handle 
   * @param {Object} colorOptions - The object with key pair values of color options available for this hit.
   * @param {string} cardColor - used to determine which image should be active on the first render
   * @param {function} mouseOverCB - Callback function triggered on thumbnail mouseover
   * @param {function} mouseOutCB - Callback function triggered on thumbnail mouseout
   * @param {function} clickCB - Callback function triggered on thumbnail click 
   * @param {strine} mediaCameraShy - fallback image url to use if image doesn't load
   * @returns {string} The rendered content HTML.
   */
  render(handle, colorOptions = {}, cardColor, mouseOverCB, mouseOutCB, clickCB, mediaCameraShy) {
    const carouselEl = this.cloneNode(true);
    const sliderWrapper = carouselEl.querySelector('ul');
    sliderWrapper.id = `Slider-${handle}`;
    
    Array.from(Object.keys(colorOptions)).forEach((option, ind) => {
      const li = document.createElement('li');
      li.classList.add('slider__slide', 'grid__item', 'algolia-hit-slider');
      li.id = `Slide-${handle}-${option}`
      const img = document.createElement('img');
      img.alt = option;
      img.src = colorOptions[option].thumbnailFrontUrl;
      img.setAttribute('onerror', `this.onerror=null;this.src='${mediaCameraShy}'`);

      if (mouseOverCB) img.addEventListener('mouseenter', mouseOverCB);
      if (mouseOutCB) img.addEventListener('mouseout', mouseOutCB);
      if (clickCB) img.addEventListener('click', clickCB);
      
      li.appendChild(img);
      if (cardColor === option) {
        img.classList.add('active');
        // the first color in the colorOptions is not always the same as the card color
        // we're force inserting the matching color to the start of
        sliderWrapper.insertBefore(li, sliderWrapper.firstChild);
      } else {
        sliderWrapper.appendChild(li);
      }
    });
    return carouselEl;
  }  
}

customElements.define("algolia-hit-carousel", AlgoliaHitCarousel);
